import type {
  CalibrationCandidate,
  GenerateCalibrationResp,
  SelectCalibrationResp,
} from '@guanwei/shared';
import { api, postStream } from './api';

// ============================================================
// 定盘
// ============================================================

export async function generateCalibration(
  chartId: string,
  modelCode?: string,
): Promise<GenerateCalibrationResp> {
  return api.post<GenerateCalibrationResp>('/calibrate', { chartId, modelCode });
}

export async function selectCalibration(
  calibrationId: string,
  selectedSchool: string,
): Promise<SelectCalibrationResp> {
  return api.post<SelectCalibrationResp>('/calibrate/select', {
    calibrationId,
    selectedSchool,
  });
}

// ============================================================
// 完整报告流式生成
// ============================================================

export interface ReportStreamHandlers {
  onChunk: (delta: string) => void;
  onDone: (reportId: string | undefined) => void;
  onError: (msg: string) => void;
}

export function streamFullReport(
  chartId: string,
  calibrationId: string,
  handlers: ReportStreamHandlers,
  modelCode?: string,
): { abort: () => void } {
  const controller = new AbortController();
  postStream(
    `/reports/charts/${chartId}/full/stream`,
    { calibrationId, modelCode },
    {
      onEvent: (event, data) => {
        if (event === 'chunk') {
          handlers.onChunk((data as { delta: string }).delta);
        } else if (event === 'done') {
          handlers.onDone((data as { reportId?: string }).reportId);
        } else if (event === 'error') {
          handlers.onError(
            (data as { message?: string }).message ?? '生成失败',
          );
        }
      },
      onError: (err) => handlers.onError(err.message),
    },
    { signal: controller.signal },
  );
  return { abort: () => controller.abort() };
}

export type { CalibrationCandidate };
